import Axios from 'axios';
import storage from 'local-storage-fallback';
import qs from 'qs';
import Auth from './auth';

export default {
  watchers: [],
  subscribe(callback) {
    this.watchers.push(callback);
  },
  post(url, data, headers, processed = false) {
    return this.api('post', url, data, processed, headers);
  },
  put(url, data) {
    return this.api('put', url, data);
  },
  get(url) {
    return this.api('get', url);
  },
  delete(url) {
    return this.api('delete', url);
  },
  api(type, url, data = null, processed = false, customHeaders = {}) {
    return new Promise((resolve, reject) => {
      const options = {
        method: type,
        url,
        headers: {...customHeaders}
      };
      if (data && processed) options.data = data;
      else if (data) options.data = qs.stringify(data);
      
      const user = JSON.parse(storage.getItem('user'));

      if (user && !user.auth_keycloak) {
        options.headers['x-auth-provider'] = 'auth0';
      }
      
      if (user && user.token && !Axios.defaults.headers.common.Authorization) {
        Axios.defaults.headers.common = {
          ...(Axios.defaults.headers.common || {}),
          Authorization: `Bearer ${user.token}`,
        };
      }
      Axios(options)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          if (!error.response) {
            reject();
            return;
          }
          if (error.response.status === 401) {
            Auth.logout();
            this.watchers.forEach(callback => {
              callback('force-logout');
            });
          } else {
            if( error.response.data.message && error.response.data.message != "pages_migration_pending" )
              reject(error);
          }
        });
    });
  }
};
